export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (!element) return;
  const headerHeight = document.querySelector('header')?.offsetHeight || 0;
  const top = element.getBoundingClientRect().top + window.scrollY - headerHeight;
  window.scrollTo({ top, behavior: 'smooth' });
};
